<div class="new-ticket-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <div>
      <h2 class="dialog-title">{{ configureOnly ? 'Configurar precios' : (edit ? 'Editar entrada' : 'Nueva entrada') }}</h2>
      <p class="dialog-subtitle" *ngIf="data?.eventName">{{ data.eventName }}</p>
    </div>
    <button class="btn-close" mat-dialog-close>
      <i class="fa-light fa-times"></i>
    </button>
  </div>

  <!-- Form -->
  <form [formGroup]="entrada" class="dialog-form">

    <!-- Nombre -->
    <div class="field" *ngIf="!configureOnly">
      <label>Nombre <span class="req">*</span></label>
      <input #nameTicket type="text" formControlName="name"
             placeholder="Nombre de la entrada" maxlength="50">
    </div>
    <div class="field" *ngIf="configureOnly">
      <p class="configure-only-name">{{ ticket?.name }}</p>
    </div>

    <!-- Configuración -->
    <div class="field" *ngIf="!configureOnly">
      <label>Configuración</label>
      <div class="checks">
        <mat-checkbox formControlName="only_tpv_sales" (change)="editOnlyTpv($event)" color="primary">
          Venta solo en taquilla
        </mat-checkbox>
        <mat-checkbox formControlName="allow_discounts" color="primary">
          Permite descuentos
        </mat-checkbox>
      </div>
    </div>

    <!-- Butacas especiales (sillas, movilidad reducida...) -->
    <div class="field" *ngIf="canChooseSpecialSeats()">
      <label>Butacas</label>
      <div class="checks">
        <mat-checkbox [checked]="specialSeats" (change)="toggleSpecialSeats($event.checked)" color="primary">
          Solo para butacas especiales
        </mat-checkbox>
      </div>

      <div class="special-seats" *ngIf="specialSeats">
        <span class="special-seats-hint">¿Qué butacas?</span>
        <div class="special-seats-groups">
          <button type="button" class="seat-group-chip" *ngFor="let group of specialSeatGroups"
                  [class.selected]="isGroupSelected(group)" (click)="selectGroup(group)">
            {{ group.name }} ({{ group.seatIds.length }})
          </button>
        </div>
      </div>
    </div>

    <!-- Zonas con precio (con mapa) -->
    <div *ngIf="levels?.length > 0" class="field">
      <label>Zonas y precios</label>

      <mat-form-field appearance="fill" class="w-100 select-zones-citylok">
        <mat-select placeholder="Todas las zonas"
                    [(ngModel)]="selectedZones" [ngModelOptions]="{standalone: true}"
                    multiple (selectionChange)="onZoneSelectionChange()">
          <mat-option [value]="'all'">Todas las zonas</mat-option>
          <mat-option *ngFor="let level of ticketsLevels" [value]="level.id">
            {{ level.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="zones-price-list">
        <div *ngFor="let level of getFilteredLevels()" class="zone-price-item"
             [class.level-disabled]="!isLevelAllowed(level)">
          <div class="zone-color-dot" [style.background]="level.color || 'var(--color-primary)'"></div>
          <span class="zone-name">{{ level.name }}</span>
          <div class="price-field">
            <input type="number" placeholder="—" [value]="level.price"
                   [disabled]="!isLevelAllowed(level)"
                   (change)="editLevelPrice($event, level, getOriginalIndex(level))"
                   (keydown)="preventNegative($event)">
            <span class="euro">€</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Precio único (sin mapa) -->
    <div *ngIf="levels?.length <= 0" class="field">
      <label>Precio</label>
      <div class="price-field standalone">
        <input type="number" formControlName="price" placeholder="—"
               min="0" (keydown)="preventNegative($event)">
        <span class="euro">€</span>
      </div>
    </div>

  </form>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" mat-dialog-close>Cancelar</button>
    <button class="btn-save" (click)="saveTicket()" [class.disabled]="entrada.invalid">
      Guardar
    </button>
  </div>

</div>
